<template>
	<div :class="{'v1 col-sm-10 offset-sm-1 offset-lg-0 col-lg-4 col-xl-3 content': version == 'v1', 'v2': version == 'v2'}">
		<h6 class="footer_title">More Calculators</h6>
		<ul>
			<li v-for="link in links" :key="link.href"><a :href="link.href">{{link.title}}</a></li>
		</ul>
		<div v-if="refinanceCalc" class="ad-sidebar-more-calc">
			<sfc-dfp-ad ad-unit="savingforcollege_refinancecalc_right_skyscraper" sizes="[[300, 600]]" :responsive="true">
			</sfc-dfp-ad>
		</div>
	</div>
</template>

<script>
export default {

	props: {
		version: {
			default: "v1",
			type: String
		}
	},

	data(){
		let allLinks = [
			{
				href: "/calculators/income-based-repayment-calculator",
				title: "Income Based Repayment Calculator"
			},
			{
				href: "/calculators/income-contingent-repayment-calculator",
				title: "Income Contingent Repayment Calculator"
			},
			{
				href: "/calculators/pay-as-you-earn-repayment-calculator",
				title: "Pay As You Earn Repayment Calculator"
			},
			{
				href: "/calculators/revised-pay-as-you-earn-repayment-calculator",
				title: "Revised Pay As You Earn Repayment Calculator"
			},
			{
				href: "/calculators/cost-of-deferment-calculator",
				title: "Cost Of Deferment Calculator"
			},
			{
				href: "/calculators/financial-aid-calculator",
				title: "Financial Aid Calculator"
			},
			{
				href: "/calculators/trust-fund-calculator",
				title: "Trust Fund Calculator"
			},
			{
				href: "/calculators/loan-calculator",
				title: "Loan Calculator"
			},
			{
				href: "/calculators/loan-comparison-calculator",
				title: "Loan Comparison Calculator"
			},
			{
				href: "/calculators/loan-prepayment-calculator",
				title: "Loan Prepayment Calculator"
			},
			{
				href: "/calculators/scholarship-tax-calculator",
				title: "Scholarship Tax Calculator"
			},
			{
				href: "/calculators/student-loan-payoff-calculator",
				title: "Student Loan Payoff Calculator"
			},
			{
				href: "/calculators/student-loan-refinance-calculator",
				title: "Student Loan Refinance Calculator"
			}
		]

		let links = []
	
		let refinanceCalc = false

		for (let index = 0; index < allLinks.length; index++) {
			if(this.$route.path != allLinks[index].href){
				links.push(allLinks[index])
			}
			if(this.$route.path == "/calculators/student-loan-refinance-calculator"){
 				refinanceCalc = true
			}
		}

		return{
			links,
			refinanceCalc
		}
	},

}
</script>

<style lang="stylus" scoped>
.v2
	.footer_title
		border-bottom: 1px solid #ced3e1;
		padding-bottom: 10px;
		margin: 25px 0;
		line-height: 1.5;
		font-weight: 500;
		font-size: 1.8rem !important
.ad-sidebar-more-calc {
    display: block;
	padding-top: 40px; 
}
@media (max-width: 991px) {
	.ad-sidebar-more-calc {
		display: none;
	}
}

</style>
